import { render, staticRenderFns } from "./cadreSchool.vue?vue&type=template&id=44822287&scoped=true&"
import script from "./cadreSchool.vue?vue&type=script&lang=js&"
export * from "./cadreSchool.vue?vue&type=script&lang=js&"
import style0 from "./cadreSchool.vue?vue&type=style&index=0&id=44822287&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44822287",
  null
  
)

export default component.exports